<script>
import {mask} from 'vue-the-mask';
export default {
  name: "VFieldMixins",
  data () {
    return {}
  },

  directives: {mask},
  methods: {

    textareaSize (event) {
      event.currentTarget.style.height = 'auto';
      event.currentTarget.style.height = (event.currentTarget.scrollHeight) + 'px';
    },

    inputFocus (event) {

      event.target.parentNode.classList.add("field-group--block-focus")

      if (!event.target.value) {
        event.target.parentNode.classList.add("field-group--block-animated")
      }

      /*if (event.target.nodeName === "TEXTAREA") {
        this.textareaSize(event.target)
      }*/
    },

    inputBlur (event) {
      event.target.parentNode.classList.remove("field-group--block-focus")

      if (!event.target.value) {
        event.target.parentNode.classList.remove("field-group--block-animated")
      }
    },
  }
}
</script>
